// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__bpw0k","container":"SearchBar_container__reTsr","input":"SearchBar_input__mQpHp","button":"SearchBar_button__Fl3TV"};